import React from 'react'

import { Footer } from '@aok/navigation'
import { Link } from '@aok/ui-elements'
import { ArrowRoundedRightup } from '@aok/icon-functional'
import { footerPropTypes } from '../../../utils/commonPropTypes'

const MagazineFooter = ({ linkLists }) => {
  const headerArea = () => (
    <div className="flex flex-col gap-y-16 600:flex-row 600:justify-between 600:items-center mb-24 1000:mb-40 ">
      <div className="font-semibold text-28 leading-36 1280:text-32 1280:leading-44">Das AOK- Gesundheitsmagazin</div>
      <div className="text-12 leading-18">© 2024 aok.de</div>
    </div>
  )

  const footerArea = () => (
    <Link
      theme="secondary"
      variant="dark"
      href="https://www.aok.de/pk/"
      icon={<ArrowRoundedRightup className="h-16 w-16 ml-4" />}
      title="www.aok.de"
      className="mt-32 1000:mt-40"
    />
  )

  return (
    <Footer
      className="pt-32 600:pt-48 1000:pt-64 pb-24"
      footerArea={footerArea()}
      headerArea={headerArea()}
      linkLists={linkLists}
    />
  )
}

MagazineFooter.propTypes = footerPropTypes

MagazineFooter.defaultProps = {
  linkLists: [],
}

export default MagazineFooter
